import type { User } from 'firebase/auth';
import * as CryptoJS from 'crypto-js';
import type { DatabaseScope } from './supabase';
import { checkPersonalBest, saveGameToDatabase } from './gameUtils';
import { get2048Target } from './game2048';
import type { Game2048Milestone, Game2048Session } from './game2048Session';

export const get2048MilestoneId = (runId: string, difficulty: number): string => {
  const hash = CryptoJS.SHA256(runId + ':' + difficulty).toString();
  return hash.slice(0, 8) + '-' + hash.slice(8, 12) + '-4' + hash.slice(13, 16) + '-8' + hash.slice(17, 20) + '-' + hash.slice(20, 32);
};

export const save2048Milestone = async (
  session: Game2048Session,
  milestone: Game2048Milestone,
  scope: DatabaseScope,
  user: User | null
): Promise<boolean> => {
  if (session.principal !== scope.principal || milestone.snapshot === null) {
    throw new Error('Invalid 2048 milestone submission scope');
  }
  const snapshot = milestone.snapshot;
  const perfectSolve = snapshot.undosUsed === 0;
  const finalTime = Math.max(1, snapshot.elapsedTime);
  const isPersonalBest = await checkPersonalBest('2048', finalTime, perfectSolve, milestone.difficulty, user, scope.client);
  const result = await saveGameToDatabase(
    '2048',
    new Date(session.identity.date + 'T00:00:00'),
    milestone.difficulty,
    finalTime,
    {
      score: snapshot.score,
      moves_made: snapshot.moves,
      max_tile: get2048Target(milestone.difficulty),
      undos_used: snapshot.undosUsed,
      perfect_solve: perfectSolve
    },
    user,
    { database: scope.client, submissionId: get2048MilestoneId(session.runId, milestone.difficulty), quiet: true }
  );
  if (!result.success) {
    throw result.error;
  }
  return isPersonalBest;
};
